import $axios from '~/plugins/axios';

import { Api, GetProductClassParams, ProductClass } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		productClassesById: {} as Dict<ProductClass>,
		items: [] as ProductClass[],
	})
	.withGetters({
		items: (state) => Object.values(state.productClassesById),
		byId: (state) => (id: number) => state.productClassesById[id],
	})
	.withMutations({
		SET (state, productClasses: ProductClass[]) {
			state.productClassesById = { ...state.productClassesById, ...createDict(productClasses, ({ id }) => id) };
		},
	})
	.withActions({
		async get ({ commit }, params: GetProductClassParams = { parentId: null }) {
			const { data } = await api.get('/product-class', { params });
			commit('SET', data.payload);
		},
	});
